import React from 'react';
import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom';
import myLogo from '../../LOGO.png';


const SmsLayout = () => {
  const location = useLocation(); // Get the current location
  const currentPath = location.pathname; // Get the current path

  const navigate = useNavigate();

  const handleGoToDashboard = () => {
    navigate('/dashboard');
  };

  const handleLogout = (e) => {
    e.preventDefault();
    // Create a hidden form to perform a POST logout
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = `${process.env.REACT_APP_NOTIFICATION_SERVICE_APIGW_ENDPOINT}/logout`;
    document.body.appendChild(form);
    form.submit();
  };

  return (
    <div className="layout">

      <div className="main-content">
        <nav className="side-pane">
          <ul>
            <li><Link to=""
              className={currentPath === '/sms' ? 'active' : ''}>SMS Notification Sent</Link></li>
            <li><Link to="sms-template"
              className={currentPath === '/sms/sms-template' ? 'active' : ''}>Template Maintenance</Link></li>
            <li><Link to="sms-category"
              className={currentPath === '/sms/sms-category' ? 'active' : ''}>SMS Category</Link></li>
            <li><Link to="sms-sender-model"
              className={currentPath === '/sms/sms-sender-model' ? 'active' : ''}>SMS Sender Model</Link></li>
            <li><Link to="sms-template-variable"
              className={currentPath === '/sms/sms-template-variable' ? 'active' : ''}>SMS Template Variable</Link></li>
            <li><Link to="sms-system-variable"
              className={currentPath === '/sms/sms-system-variable' ? 'active' : ''}>SMS Variable</Link></li>
            <li className="logout-item">
              <button
                type="button"
                onClick={handleLogout}
                className="logout-button"
                style={{ marginTop: '20px', cursor: 'pointer' }}
              >
                Logout
              </button>
            </li>
            <li className="back-to-dashboard-item">
              <button
                type="button"
                onClick={handleGoToDashboard}
                className="back-to-dashboard-button"
                style={{ marginTop: '20px', cursor: 'pointer' }}
              >
                Dashboard
              </button>
            </li>
          </ul>
        </nav>
        <div className="content-pane">
          <Outlet /> {/* This is crucial for rendering child route components */}
          <footer className="company-footer">
            <img src={myLogo} alt="Logo" className="footer-logo" />

            <div className="footer-info">
              <p className="copyright-text">
                &copy; {new Date().getFullYear()} PRIMEDHA Technologies Pvt Ltd. All rights reserved.
              </p>
            </div>
          </footer>
        </div>
      </div>
    </div>
  );
};

export default SmsLayout;
